const FOOTER_LINKS = [
  { href: "#hero", label: "Feast" },
  { slug: "starters", label: "Starters" },
  { slug: "mains", label: "Mains" },
  { slug: "biryani", label: "Biryani" },
  { slug: "chinese", label: "Chinese" },
  { href: "#contact", label: "Location" },
];

export default function Footer({ info, onSelectCategory }) {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#070D11] border-t border-[#1E313D] py-12 px-6"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-full bg-[#D4AF37] text-[#0B1319] flex items-center justify-center font-serif font-bold text-xs">
            A
          </div>
          <div>
            <span className="font-display font-bold text-sm tracking-wider text-[#F7D774]">
              {info?.full_name || "AL-HAMEEDIYA RESTAURANT"}
            </span>
            <p className="text-[11px] text-[#A8B8C0]">
              {info?.tagline || "Good Food • Great Taste Always"}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-6 text-xs text-[#A8B8C0]">
          {FOOTER_LINKS.map((link) =>
            link.slug ? (
              <button
                key={link.slug}
                onClick={() => onSelectCategory?.(link.slug)}
                data-testid={`footer-link-${link.label.toLowerCase()}`}
                className="hover:text-[#F7D774] transition-colors"
              >
                {link.label}
              </button>
            ) : (
              <a
                key={link.href}
                href={link.href}
                data-testid={`footer-link-${link.label.toLowerCase()}`}
                className="hover:text-[#F7D774] transition-colors"
              >
                {link.label}
              </a>
            )
          )}
        </div>
        <p className="text-xs text-[#6C7D86]">
          {info?.location || "Nagpur, Maharashtra"}
        </p>
      </div>
    </footer>
  );
}
